import React from "react";

export default function TaskFilters({
  employees,
  assigneeFilter,
  priorityFilter,
  overdueOnly = false,
  watcherOnly = false,
  onAssigneeChange,
  onPriorityChange,
  onOverdueChange,
  onWatcherOnlyChange,
  onClear,
  filtersActive,
}) {
  return (
    <div className="task-filters">
      <div className="task-filters-group">
        <label className="task-filter-field">
          <span className="task-filter-label">Исполнитель</span>
          <select
            className="task-form-select"
            value={assigneeFilter}
            onChange={(e) => onAssigneeChange(e.target.value)}
          >
            <option value="">Все</option>
            <option value="none">Без исполнителя</option>
            {employees.map((emp) => (
              <option key={emp.id} value={emp.id}>
                {emp.full_name}
              </option>
            ))}
          </select>
        </label>

        <label className="task-filter-field">
          <span className="task-filter-label">Приоритет</span>
          <select
            className="task-form-select"
            value={priorityFilter}
            onChange={(e) => onPriorityChange(e.target.value)}
          >
            <option value="">Все</option>
            <option value="high">Высокий</option>
            <option value="medium">Средний</option>
            <option value="low">Низкий</option>
          </select>
        </label>

        <label className="task-filter-checkbox">
          <input
            type="checkbox"
            checked={overdueOnly}
            onChange={(e) => onOverdueChange?.(e.target.checked)}
          />
          <span>Только просроченные</span>
        </label>

        <label className="task-filter-checkbox">
          <input
            type="checkbox"
            checked={watcherOnly}
            onChange={(e) => onWatcherOnlyChange?.(e.target.checked)}
          />
          <span>Я наблюдатель</span>
        </label>
      </div>

      {filtersActive && (
        <button type="button" className="btn btn-sm task-filter-clear" onClick={onClear}>
          Сбросить фильтры
        </button>
      )}
    </div>
  );
}
